/**
 * Lightweight cache for scene and organization data to speed up navigation
 * (e.g. when going back from caption editor to scene edit page).
 */
const TTL_MS = 2 * 60 * 1000; // 2 minutes

const cache = {
  organizations: null,
  organizationsTs: 0,
  scenes: new Map(), // orgId -> { data, ts }
};

export function setOrganizations(data) {
  cache.organizations = data;
  cache.organizationsTs = Date.now();
}

export function getOrganizations() {
  if (!cache.organizations || Date.now() - cache.organizationsTs > TTL_MS) return null;
  return cache.organizations;
}

export function setScenesByOrg(orgId, data) {
  cache.scenes.set(orgId, { data, ts: Date.now() });
}

export function getScenesByOrg(orgId) {
  const entry = cache.scenes.get(orgId);
  if (!entry || Date.now() - entry.ts > TTL_MS) return null;
  return entry.data;
}

export function invalidateScenesByOrg(orgId) {
  cache.scenes.delete(orgId);
}
